import React, {Component} from 'react'
import PropTypes from 'prop-types';
import { format,addDays } from 'date-fns';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Pagination from '@material-ui/lab/Pagination';
import Paper from '@material-ui/core/Paper';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import DatePicker from "react-datepicker";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import BreadCrumbNav from '../BreadCrumbNav';
// import { getUser } from '../../helpers';
import { Button } from '@material-ui/core';
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { getUser,getUserSort,getComparator,stableSort,getFilterOptions } from '../../helpers';

import './WorkHistory.css'
import { orderBy } from 'lodash';

// const kWeekday = ["（日）","（月）","（火）","（水）","（木）","（金）","（土）"];
// function getUserSort() {
//   let userdata = {order: 'asc', orderBy: 'systemNo'};
//   let item = localStorage.getItem('setting-user-sort');
//   if (item && item !== 'undefined') {
//       let setting = JSON.parse(item);
//       if (setting && setting.order && setting.orderBy) {
//           userdata = setting;
//       }
//   }
//   return userdata;
// }

// function descendingComparator(a, b, orderBy) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

// function getComparator(order, orderBy) {
//   return order === 'desc'
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy);
// }

// function stableSort(array, comparator) {
//   const stabilizedThis = array.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });
//   return stabilizedThis.map((el) => el[0]);
// }
class WorkHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 100,
      date: null,
      user_name: null,
      user_id: null,
      section_name: null,
      section_id: null,
      department_name: null,
      department_id: null,
      pc_name: null,
      mac_add: null,
      startDate: new Date(),
      endDate: new Date(),
      startDateValid: false,
      firstLoad: true,
      order: "desc", 
      orderBy: "start_time",
    };
  }


  fetchWorkHistories(offset, startDate, endDate) {    
    const { getWorkHistories } = this.props
    const params = {
      // offset: offset*this.state.limit,
      // limit: this.state.limit,
      date: format(Date.now(), 'yyyy-MM-dd'),
      startDate: startDate ? format(startDate, 'yyyy-MM-dd') : "",
      // startDate: this.startDate? format(this.startDate, 'yyyy-MM-dd') : "",
      endDate: format(endDate, 'yyyy-MM-dd'),
      user_name: this.state.user_name,
      pc_name: this.state.pc_name,
      section_name: this.state.section_name,
      department_name: this.state.department_name,
      user_id : this.state.user_id,
      section_id : this.state.section_id,
      department_id : this.state.department_id,
      mac_add : this.state.mac_add,
    };
    getWorkHistories(params);
    this.setState({offset, endDate});
    if (startDate) {
      this.setState({startDateValid: true, startDate});
    }
  }

  // fetchFilter(startDate, endDate) {
  //   const { getFilters } = this.props;
  //   const params = {
  //     startDate: startDate ? format(startDate, 'yyyy-MM-dd') : "",
  //     endDate: format(endDate, 'yyyy-MM-dd'),
  //   };
  //   getFilters(params);
  // }

  componentDidMount() {
    let startDate = undefined;
    let endDate = new Date();
    const search = this.props.location.search;
    const query = new URLSearchParams(search);
    const d = query.get('date');
    if (d) {
      startDate = new Date(d);
      endDate = new Date(d);
    } else {
      let c=new Date();
      // c.setDate(c.getDate() - 365);
      // 検索期間デフォルト：前月1日～現在まで
      // c = addMonths(c, -1);
      c = addDays(c, -7);
      // c.setDate(1);
      startDate = new Date(c);
      endDate = new Date();
      this.setState({startDate, endDate});
    }
    
    // 稼働履歴取得
    this.fetchWorkHistories(this.state.offset, startDate, endDate);
    // this.fetchFilter(startDate, endDate);
  }

  handleClickDownloadCSV = (filteredItems) => {
    const csvRows = ["検索条件："]; 
    csvRows.push("　期間: " + format(this.state.startDate, 'yyyy/MM/dd') + "～" + format(this.state.endDate, 'yyyy/MM/dd'));
    
    if (this.state.user_name === null) {
      csvRows.push("　ユーザー名: すべて");
    } else if (this.state.user_name === "") {
      csvRows.push("　ユーザー名: 空白");
    } else {
      csvRows.push("　ユーザー名: " + this.state.user_name);
    };

    if (this.state.section_name === null) {
      csvRows.push("　部: すべて");
    } else if (this.state.section_name === "") {
      csvRows.push("　部: 空白");
    } else {
      csvRows.push("　部: " + this.state.section_name);
    };

    if (this.state.department_name === null) {
      csvRows.push("　課: すべて");
    } else if (this.state.department_name === "") {
      csvRows.push("　課: 空白");
    } else {
      csvRows.push("　課: " + this.state.department_name);
    };

    if (this.state.pc_name === null) {
      csvRows.push("　端末番号: すべて");
    } else if (this.state.pc_name === "") {
      csvRows.push("　端末番号: 空白");
    } else {
      csvRows.push("　端末番号: " + this.state.pc_name);
    };
    
    const csvHeaderTitles = ["ユーザー名", "部", "課", "端末番号", "PC 情報(モデル名)", "起動日時", "終了日時", "稼働時間"];
    csvRows.push([csvHeaderTitles.join(',')]);
  
    filteredItems.forEach(item => {
      const row = [
        item.user_name,
        item.section_name,
        item.department_name,
        item.pc_name,
        item.system_model,
        `\t${item.start_time}`,  
        `\t${item.shutdown_time}`,
        `\t${item.active_time}`,
      ];
      csvRows.push(row.map(v => `"${v.toString().replace(/"/g, '""')}"`).join(','));
    });
  
    const csvData = csvRows.join('\n');
    const BOM = '\uFEFF'; // BOM cho UTF-8
    const blob = new Blob([BOM + csvData], { type: 'text/csv;charset=utf-8;' });

    const date = new Date();
    const options = {
      timeZone: "Asia/Tokyo",
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };

    const formattedDate = new Intl.DateTimeFormat('ja-JP', options).format(date).replace(/\D/g, ''); 
    const filename = `稼働履歴_${formattedDate}.csv`;

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  changePagination = (event, newPage) => {
    const newOffset = newPage - 1;
    this.setState({
      offset: newOffset
    });
  };

  render() {
    const user = getUser();
    const { items,  isFetching,  startDate} = this.props

    const filteredItems = items
      ? (
          stableSort(items.detailData || [], getComparator(this.state.order, this.state.orderBy))
        ).filter(
          (item) =>
        {
        return (

          ( this.state.user_name === null ? true : this.state.user_name === "" ? item.user_name === "" 
            : this.state.user_id !== null ? item.user_id === this.state.user_id
            : item.user_name && item.user_name.includes(this.state.user_name)
          ) &&

           ( this.state.section_name === null ? true : this.state.section_name === "" ? item.section_name === "" 
            : this.state.section_id !== null ? item.section_id === this.state.section_id
            : item.section_name && item.section_name.includes(this.state.section_name)
          ) &&

          ( this.state.department_name === null ? true : this.state.department_name === "" ? item.department_name === "" 
            : this.state.department_id !== null ? item.department_id === this.state.department_id
            : item.department_name && item.department_name.includes(this.state.department_name)
          ) &&

          ( this.state.pc_name === null ? true : this.state.pc_name === "" ? item.pc_name === "" 
                : this.state.mac_add !== null ? item.mac_add === this.state.mac_add
                : item.pc_name && item.pc_name.includes(this.state.pc_name)
              ) 

        // (this.state.user_id === null  || (this.state.user_id === item.user_id)) &&
        // (this.state.department_id === null || (this.state.department_id === item.department_id)) &&
        // (this.state.section_id === null || (this.state.section_id === item.section_id)) &&
        // (this.state.mac_add === null || (this.state.mac_add === item.mac_add)) &&
        // (this.state.user_name === null || (this.state.user_name === "") || (this.state.user_name !== "" && item.user_name.includes(this.state.user_name) )) &&
        // (this.state.section_name === null || (this.state.section_name === "" ) || (this.state.section_name !== "" && item.section_name.includes(this.state.section_name) )) &&
        // (this.state.department_name === null || (this.state.department_name === "") || (this.state.department_name !== "" && item.department_name.includes(this.state.department_name) )) &&
        // (this.state.pc_name === null || (this.state.pc_name === "") || (this.state.pc_name !== "" && item.pc_name.includes(this.state.pc_name) )) 
        )
        }
      )
    : [];
    // フィルターデータ設定
    let user_options,department_options,section_options,pc_spec_options;
    if (filteredItems.length >0){
      user_options=getFilterOptions(filteredItems,["user_id","user_name"],"user_name","user_name")
                  .sort((a, b) => a.user_name.localeCompare(b.user_name, undefined, {sensitivity: "base", numeric: true}));

      section_options=getFilterOptions(filteredItems,["section_id","section_name"],"section_name","section_name")
                  .sort((a, b) => a.section_name.localeCompare(b.section_name, undefined, {sensitivity: "base", numeric: true}));

      department_options=getFilterOptions(filteredItems,["department_id","department_name"],"department_name","department_name")
                  .sort((a, b) => a.department_name.localeCompare(b.department_name, undefined, {sensitivity: "base", numeric: true}));

      pc_spec_options=getFilterOptions(filteredItems,["mac_add","pc_name"],"pc_name","pc_name")
                  .sort((a, b) => a.pc_name.localeCompare(b.pc_name, undefined, {sensitivity: "base", numeric: true}));

    }
    
    // const displayedItems = filteredItems.slice(offset * limit, (offset + 1) * limit);
    const displayedItems = filteredItems.slice(this.state.offset * this.state.limit, (this.state.offset + 1) * this.state.limit);


    // const changePagination = (event, val) => {
    //   this.setState({firstLoad: false});
    //   // 稼働履歴取得
    //   this.fetchWorkHistories((val-1), this.state.startDateValid ? this.state.startDate : new Date(startDate), this.state.endDate);
    // };

    // フィルターデータ変更時の処理
    const handleChangeFilter = (filterDict) => {
      const { changeFilterDatas } = this.props
      this.setState({ ...this.state,firstLoad: false,orderBy: 'start_time',order:'desc',...filterDict});
      createSortHandler("start_time");
      changeFilterDatas({...filterDict});
    };
    const handleChangeStartDate = (date) => {
      let deltaTime =10;
      // if (this.state.department_id || this.state.section_id|| this.state.user_id || this.state.mac_add){
      //   deltaTime=30;
      // }else{
      //   deltaTime=10;
      // }
      const diffDateTime =(this.state.endDate - date)/(1000*60*60*24);
      if (diffDateTime < 0){
        window.alert(`開始日付より終了日付が未来になるように設定ください。`);
        return false;
      }
      if (diffDateTime>deltaTime) {
        window.alert(`開始日付から終了日付までの期間が${deltaTime}日以内になるように設定ください。`);
        return false;
      }
      this.setState({firstLoad: false,startDate:date});
      // 稼働履歴取得
      this.fetchWorkHistories(0, date, this.state.endDate);
      // this.fetchFilter(date, this.state.endDate);
    };

    const handleChangeEndDate = (date) => {
      let deltaTime =10;
      // if (this.state.department_id || this.state.section_id|| this.state.user_id || this.state.mac_add){
      //   deltaTime=30;
      // }else{
      //   deltaTime=10;
      // }
      const diffDateTime =(date-this.state.startDate)/(1000*60*60*24);
      if (diffDateTime < 0){
        window.alert(`開始日付より終了日付が未来になるように設定ください。`);
        return false;
      }
      if (diffDateTime>deltaTime) {
        window.alert(`開始日付から終了日付までの期間が${deltaTime}日以内になるように設定ください。`);
        return false;
      }
      this.setState({firstLoad: false,endDate:date});
      // 稼働履歴取得
      this.fetchWorkHistories(0, this.state.startDateValid ? this.state.startDate : new Date(startDate), date);
      // this.fetchFilter(this.state.startDateValid ? this.state.startDate : new Date(startDate), date);
    };

    const createSortHandler = (property) => (event) => {
      const isAsc = this.state.orderBy === property && this.state.order === 'asc';
      const order = {order: isAsc ? 'desc' : 'asc'};
      this.setState(order);

      const orderBy = {orderBy: property};
      this.setState({
        ...order,
        ...orderBy,
        i_num: -1,
        firstLoad: false,
      });
      localStorage.setItem('setting-user-sort', JSON.stringify({...order, ...orderBy}));
    };

    // const { limit, offset } = this.state;
    // const sortedItems = items && items.detailData
    //                     ? stableSort(items.detailData, getComparator(this.state.order, this.state.orderBy))
    //                     : [];
    // const displayedItems = sortedItems.slice(offset * limit, (offset + 1) * limit);
  
    return (
      <div className="workhistory-container">
        {this.state.firstLoad && isFetching ? <div className='loading'>お待ちください．．．</div>
          :<>
          <BreadCrumbNav screenName="稼働履歴"></BreadCrumbNav>
          <div className="loginname">ログイン名：{user.username}</div>
          <div className="workhistory-filter">
            <FormControl variant="outlined" className="workhistory-filter__item">
              <InputLabel className="filter-label">期間：</InputLabel>
              <div className="workhistory-daterange">
                <DatePicker
                  className="date-picker"
                  selected={!this.state.startDateValid && startDate ? new Date(startDate) : this.state.startDate }
                  onChange={(date) => handleChangeStartDate(date)}
                  selectsStart
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  dateFormat="yyyy/MM/dd"
                  // minDate={this.state.startDateValid ? new Date(this.state.endDate.getFullYear()-2, this.state.endDate.getMonth(), this.state.endDate.getDate()) : {}}
                  minDate={this.state.startDateValid ? new Date(this.state.endDate.getFullYear(), this.state.endDate.getMonth()-2, this.state.endDate.getDate()) : {}}
                />
                <div className="date-picker">〜</div>
                <DatePicker
                  className="date-picker"
                  selected={this.state.endDate}
                  onChange={(date) => handleChangeEndDate(date)}
                  selectsEnd
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  minDate={!this.state.startDateValid && startDate ? new Date(startDate) : this.state.startDate}
                  // maxDate={new Date(this.state.startDate.getFullYear()+2, this.state.startDate.getMonth(), this.state.startDate.getDate())}
                  maxDate={new Date(this.state.startDate.getFullYear(), this.state.startDate.getMonth()+2, this.state.startDate.getDate())}
                  dateFormat="yyyy/MM/dd"
                />
              </div>
            </FormControl>

            <FormControl className="formhistory-filter">
              <Autocomplete
                freeSolo
                // disableClearable
                id="combo-box-autocomplete-user_name"
                className="combo-box-autocomplete"
                value={this.state.user_name}
                onChange={(event, newValue) => {
                  if (!newValue) {
                    handleChangeFilter({
                      user_name: null,
                      user_id: null,
                      firstLoad: false,
                      offset: 0
                    });
                  } else {
                    handleChangeFilter({
                      user_id: newValue.user_id ?? null,
                      user_name: newValue.user_name ?? "",
                      firstLoad: false,
                      offset: 0
                    });
                  }
                }}
                onInputChange={(event, value) => {
                  if (event && event.type === "change") {
                    handleChangeFilter({user_name:value,user_id:null,firstLoad: false , offset: 0 });
                  }
                }}
                options={
                  this.state.user_name && this.state.user_name.trim() !== "" && user_options
                    ? user_options.filter(item => item.user_name.toLowerCase().includes(this.state.user_name.toLowerCase()))
                    : user_options || []
                }
                getOptionLabel={(option) => 
                  typeof option === 'string' ? option : option?.user_name || ''
                }

                // onChange={(event, newValue) => {
                //   console.log("onChange", newValue);
                //   handleChangeFilter("user_name", newValue);
                // }}
                // onInputChange={(e,value) => {
                //   if(e.type === "change") {
                //     console.log("onInputChange", value);
                    
                //     this.setState({firstLoad: false, user_name: value, selected_user_name: undefined});
                //     this.fetchWorkHistories(0, 
                //       this.state.startDateValid ? this.state.startDate : new Date(startDate), 
                //       this.state.endDate,
                //       value, 
                //       this.state.section_name, 
                //       this.state.department_name, 
                //       this.state.pc_name,
                //       undefined, 
                //       this.state.selected_section_name, 
                //       this.state.selected_department_name, 
                //       this.state.selected_pc_name);
                //     }
                //   }
                // }
                // options={userOptions()}
                // getOptionLabel={(option) => option}
                renderInput={(params) => 
                  <TextField 
                    {...params} 
                    className="autocomplete-filter" 
                    label="ユーザー名：" 
                    variant="outlined" 
                    fullWidth
                  />
                }
              />
            </FormControl>

            <FormControl className="formhistory-filter">
              <Autocomplete
                freeSolo
                // disableClearable
                id="combo-box-autocomplete-section_name"
                className="combo-box-autocomplete"
                value={this.state.section_name}
                // onChange={(event, newValue) => {
                //   handleChangeFilter("section_name", newValue);
                // }}
                // onInputChange={(e,value) => {
                //   if(e.type === "change") {
                //     this.setState({firstLoad: false, section_name: value, selected_section_name: undefined});
                //     this.fetchWorkHistories(0, 
                //       this.state.startDateValid ? this.state.startDate : new Date(startDate), 
                //       this.state.endDate, 
                //       this.state.user_name,
                //       value, 
                //       this.state.department_name,
                //       this.state.pc_name,
                //       this.state.selected_user_name, 
                //       undefined,
                //       this.state.selected_department_name,
                //       this.state.selected_pc_name);
                //     }
                //   }
                // }
                // options={sectionOptions()}
                // getOptionLabel={(option) => option}
                // onChange={(event, newValue) => {
                //     handleChangeFilter({section_id:newValue&&newValue.section_id?newValue.section_id:null,section_name: newValue&&newValue.section_name?newValue.section_name:"",firstLoad: false , offset: 0});
                // }}
                onChange={(event, newValue) => {
                  if (!newValue) {
                    handleChangeFilter({
                      section_name: null,
                      section_id: null,
                      firstLoad: false,
                      offset: 0
                    });
                  } else {
                    handleChangeFilter({
                      section_id: newValue.section_id ?? null,
                      section_name: newValue.section_name ?? "",
                      firstLoad: false,
                      offset: 0
                    });
                  }
                }}
                onInputChange={(event, value) => {
                  if (event && event.type === "change") {
                    handleChangeFilter({section_name:value,section_id:null,firstLoad: false , offset: 0});
                    }
                }}
                options={
                  this.state.section_name && this.state.section_name.trim() !== "" && section_options
                    ? section_options.filter(item => item.section_name.toLowerCase().includes(this.state.section_name.toLowerCase()))
                    : section_options || []
                }
                getOptionLabel={(option) => 
                  typeof option === 'string' ? option : option?.section_name || ''
                }

                renderInput={(params) => 
                  <TextField 
                    {...params} 
                    className="autocomplete-filter" 
                    label="部：" 
                    variant="outlined" 
                    fullWidth
                  />
                }
              />
            </FormControl>
            
            <FormControl className="formhistory-filter">
              <Autocomplete
                freeSolo
                // disableClearable
                id="combo-box-autocomplete-department_name"
                className="combo-box-autocomplete"
                value={this.state.department_name}
                // onChange={(event, newValue) => {
                //   handleChangeFilter("department_name", newValue);
                // }}
                // onInputChange={(e,value) => {
                //   if(e.type === "change") {
                //     this.setState({firstLoad: false, department_name: value, selected_department_name: undefined});
                //     this.fetchWorkHistories(0, 
                //       this.state.startDateValid ? this.state.startDate : new Date(startDate), 
                //       this.state.endDate, 
                //       this.state.user_name,
                //       this.state.section_name,
                //       value, 
                //       this.state.pc_name,
                //       this.state.selected_user_name, 
                //       this.state.selected_section_name,
                //       undefined,
                //       this.state.selected_pc_name);
                //     }
                //   }
                // }
                // options={departmentOptions()}
                // getOptionLabel={(option) => option}
                // onChange={(event, newValue) => {
                //     handleChangeFilter({department_id:newValue&&newValue.department_id?newValue.department_id:null,department_name: newValue&&newValue.department_name?newValue.department_name:"", firstLoad: false , offset: 0});
                // }}
                onChange={(event, newValue) => {
                  if (!newValue) {
                    handleChangeFilter({
                      department_name: null,
                      department_id: null,
                      firstLoad: false,
                      offset: 0
                    });
                  } else {
                    handleChangeFilter({
                      department_id: newValue.department_id ?? null,
                      department_name: newValue.department_name ?? "",
                      firstLoad: false,
                      offset: 0
                    });
                  }
                }}
                onInputChange={(event, value) => {
                  if (event && event.type === "change") {
                    handleChangeFilter({department_name:value,department_id:null,firstLoad: false , offset: 0 });
                  }
                }}

                options={
                  this.state.department_name && this.state.department_name.trim() !== "" && department_options
                    ? department_options.filter(item => item.department_name.toLowerCase().includes(this.state.department_name.toLowerCase()))
                    : department_options || []
                }

                getOptionLabel={(option) => 
                  typeof option === 'string' ? option : option?.department_name || ''
                }

                renderInput={(params) => 
                  <TextField 
                    {...params} 
                    className="autocomplete-filter" 
                    label="課：" 
                    variant="outlined" 
                    fullWidth
                  />
                }
              />
            </FormControl>

            <FormControl className="formhistory-filter">
              <Autocomplete
                freeSolo
                // disableClearable
                id="combo-box-autocomplete-pc_name"
                className="combo-box-autocomplete"
                value={this.state.pc_name}
                // onChange={(event, newValue) => {
                //     handleChangeFilter({mac_add:newValue&&newValue.mac_add?newValue.mac_add:null,pc_name: newValue&&newValue.pc_name?newValue.pc_name:"", firstLoad: false , offset: 0});
                // }}
                onChange={(event, newValue) => {
                if (!newValue) {
                  handleChangeFilter({
                    pc_name: null,
                    mac_add: null,
                    firstLoad: false,
                    offset: 0
                  });
                } else {
                  handleChangeFilter({
                    mac_add: newValue.mac_add ?? null,
                    pc_name: newValue.pc_name ?? "",
                    firstLoad: false,
                    offset: 0
                  });
                }
              }}
                onInputChange={(event, value) => {
                  if (event && event.type === "change") {
                    handleChangeFilter({pc_name:value,mac_add:null, firstLoad: false , offset: 0});
                  }
                }}
                options={
                  this.state.pc_name && this.state.pc_name.trim() !== "" && pc_spec_options
                    ? pc_spec_options.filter(item => item.pc_name.toLowerCase().includes(this.state.pc_name.toLowerCase()))
                    : pc_spec_options || []
                }
                getOptionLabel={(option) => 
                  typeof option === 'string' ? option : option?.pc_name || ''
                }
                // onChange={(event, newValue) => {
                //   handleChangeFilter("pc_name", newValue);
                // }}
                // onInputChange={(e,value) => {
                //   if(e.type === "change") {
                //     this.setState({firstLoad: false, pc_name: value, selected_pc_name: undefined});
                //     this.fetchWorkHistories(0, 
                //       this.state.startDateValid ? this.state.startDate : new Date(startDate), 
                //       this.state.endDate, 
                //       this.state.user_name,
                //       this.state.section_name,
                //       this.state.department_name, 
                //       value,
                //       this.state.selected_user_name, 
                //       this.state.selected_section_name, 
                //       this.state.selected_department_name, 
                //       undefined);
                //     }
                //   }
                // }
                // options={pcOptions()}
                // getOptionLabel={(option) => option}
                renderInput={(params) => 
                  <TextField 
                    {...params} 
                    className="autocomplete-filter" 
                    label="端末番号：" 
                    variant="outlined" 
                    fullWidth
                  />
                }
              />
            </FormControl>

            <FormControl className="WorkHistory-download">
              <Button
                variant="contained"
                color="primary"
                className="download-button"
                onClick={() => this.handleClickDownloadCSV(filteredItems)}
                disabled={!this.props.items || this.props.items.length === 0}
              >
                ダウンロード
              </Button>
            </FormControl>

            <div className='workhistory-item-count'>
            <b> 検索結果：{filteredItems.length}件 </b>
            </div>

          </div>
          
          <Box sx={{ width: '100%', height: '2px' }}>
            {isFetching && <LinearProgress />}
          </Box>
          <Paper className="table-root">
            <TableContainer className="workhistory-table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {/* <TableCell align="center" style={{ minWidth: 150 }}>日付</TableCell> */}
                    {/* <TableCell align="center" style={{ minWidth: 200 }}>ユーザー名</TableCell> */}
                     <TableCell 
                      key="user_name"
                      align="center" 
                      sortDirection={this.state.orderBy === "user_name" ? this.state.order : false}
                      style={{ minWidth: 200 }}
                      >
                        <TableSortLabel
                          //active={this.state.orderBy === "user_name"}
                          direction={this.state.orderBy === "user_name" ? this.state.order : 'asc'}
                          onClick={createSortHandler("user_name")}
                        >
                          ユーザー名
                          {this.state.orderBy === "user_name" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                            ) : null}
                        </TableSortLabel>                    
                    </TableCell>
                    {/* <TableCell align="center" style={{ minWidth: 180 }}>部</TableCell> */}
                    <TableCell 
                      key="section_name"
                      align="center" 
                      sortDirection={this.state.orderBy === "section_name" ? this.state.order : false}
                      style={{ minWidth: 180 }}
                    >              
                      <TableSortLabel
                        direction={this.state.orderBy === "section_name" ? this.state.order : 'asc'}
                        onClick={createSortHandler("section_name")}
                      >
                        部
                        {this.state.orderBy === "section_name" ? (
                          <span className="visuallyHidden">
                            {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null}
                      </TableSortLabel>  
                    </TableCell>
                    {/* <TableCell align="center" style={{ minWidth: 180 }}>課</TableCell> */}
                    <TableCell 
                      key="department_name"
                      align="center" 
                      sortDirection={this.state.orderBy === "department_name" ? this.state.order : false}
                      style={{ minWidth: 180 }}
                    >              
                      <TableSortLabel
                        direction={this.state.orderBy === "department_name" ? this.state.order : 'asc'}
                        onClick={createSortHandler("department_name")}
                      >
                        課
                        {this.state.orderBy === "department_name" ? (
                          <span className="visuallyHidden">
                            {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null}
                      </TableSortLabel>  
                    </TableCell>
                    {/* <TableCell align="center" style={{ minWidth: 100 }}>端末番号</TableCell> */}
                    <TableCell 
                      key="pc_name"
                      align="center" 
                      sortDirection={this.state.orderBy === "pc_name" ? this.state.order : false}
                      style={{ minWidth: 100 }}
                    >              
                      <TableSortLabel
                        direction={this.state.orderBy === "pc_name" ? this.state.order : 'asc'}
                        onClick={createSortHandler("pc_name")}
                      >
                        端末番号
                        {this.state.orderBy === "pc_name" ? (
                          <span className="visuallyHidden">
                            {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null}
                      </TableSortLabel>  
                    </TableCell>
                    {/* <TableCell align="center" style={{ minWidth: 200 }}>PC 情報(モデル名)</TableCell> */}
                    <TableCell 
                      key="system_model"
                      align="center" 
                      sortDirection={this.state.orderBy === "system_model" ? this.state.order : false}
                      style={{ minWidth: 200 }}
                    >              
                      <TableSortLabel
                        direction={this.state.orderBy === "system_model" ? this.state.order : 'asc'}
                        onClick={createSortHandler("system_model")}
                      >
                        PC 情報(モデル名)
                        {this.state.orderBy === "system_model" ? (
                          <span className="visuallyHidden">
                            {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null}
                      </TableSortLabel>  
                    </TableCell>
                    {/* <TableCell align="center" style={{ minWidth: 100 }}>起動日時</TableCell> */}
                    <TableCell 
                      key="start_time"
                      align="center" 
                      sortDirection={this.state.orderBy === "start_time" ? this.state.order : false}
                      style={{ minWidth: 200 }}
                    >              
                      <TableSortLabel
                        direction={this.state.orderBy === "start_time" ? this.state.order : 'asc'}
                        onClick={createSortHandler("start_time")}
                      >
                        起動日時
                        {this.state.orderBy === "start_time" ? (
                          <span className="visuallyHidden">
                            {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null}
                      </TableSortLabel>  
                    </TableCell>
                    {/* <TableCell align="center" style={{ minWidth: 100 }}>終了日時</TableCell> */}
                    <TableCell 
                      key="shutdown_time"
                      align="center" 
                      sortDirection={this.state.orderBy === "shutdown_time" ? this.state.order : false}
                      style={{ minWidth: 200 }}
                    >              
                      <TableSortLabel
                        direction={this.state.orderBy === "shutdown_time" ? this.state.order : 'asc'}
                        onClick={createSortHandler("shutdown_time")}
                      >
                        終了日時
                        {this.state.orderBy === "shutdown_time" ? (
                          <span className="visuallyHidden">
                            {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null}
                      </TableSortLabel>  
                    </TableCell>
                    <TableCell align="center" style={{ minWidth: 100 }}>稼働時間</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {displayedItems.map((item, index) => (
                    <TableRow key={index}>
                      {/* <TableCell align="center" component="th" scope="row">{item.strDateTime}</TableCell> */}
                      <TableCell align="center">{item.user_name}</TableCell>
                      <TableCell align="center">{item.section_name}</TableCell>
                      <TableCell align="center">{item.department_name}</TableCell>
                      <TableCell align="center">{item.pc_name}</TableCell>
                      <TableCell align="center">{item.system_model}</TableCell>
                      <TableCell align="center">{item.start_time}</TableCell>
                      <TableCell align="center">{item.shutdown_time}</TableCell>
                      <TableCell align="center">{item.active_time}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            { filteredItems.length > 0 && 
              <div className='pagination-button'>
                <Pagination
                  page={this.state.offset + 1}
                  count={Math.ceil(filteredItems.length / this.state.limit)}
                  onChange={this.changePagination}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            }
          </Paper>
          </>
        }
      </div>
    );
  }
}

WorkHistory.propTypes = {
  getWorkHistories: PropTypes.func.isRequired,
  changeFilterDatas: PropTypes.func.isRequired,
};

export default WorkHistory;